import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StyledTopBarContainer, StyledSelect, StyledOption, StyledStyledSortTitle, StyledStyledTitle, StyledTopBarWrapper } from './TopBar.styled';
import ListStyleImage from "../../../assets/images/list_style.png"
import Button from '../../Button/Button';

interface Props {
    selectedDate: string
    setSelectedDate: (value: string) => void
}

const TopBar = (props: Props) => {
    const navigate = useNavigate();

    const handleClickFullView = () => {
        navigate('/leaderboard'); // Navigate to the 'About' page
    };

    return (
        <StyledTopBarContainer>
            <StyledTopBarWrapper>
                <StyledStyledTitle>Sports Picks</StyledStyledTitle>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <StyledStyledSortTitle>Date: </StyledStyledSortTitle>
                    <input
                        type="date"
                        value={props.selectedDate}
                        onChange={(e) => props.setSelectedDate(e.target.value)}
                    />
                </div>
            </StyledTopBarWrapper>
        </StyledTopBarContainer>
    );
}

export default TopBar;
